import React, {Fragment} from 'react';
import {Box, Tooltip, Button} from "@mui/material";
import {HeadingContainer,CloseSaveModal,StyledSaveModal,SaveDraftControl,SaveDraftControlLabel,SaveDraftForm,SaveDraftGroup,SaveIcon} from "../../styles/jss/components/savemodal";

interface SaveModalProperties{
    show: boolean;
    handleCloseModal: any;
    handleModalSubmit: any;
    saveEmailAddress: string;
    saveEmailSubject: string;
    handleEmailAddressChange: any;
    handleEmailSubjectChange: any;
    saveEmailAddressErrorMessage: string;
    saveEmailSubjectErrorMessage: string;
    copySuccess: string;
    copyToClipboard: any;
    copiedToClipboard: any;
    savedStateAppUrl: any;
}

const SaveModal = (props: SaveModalProperties) => {

    const modalStyle = {
        position: 'absolute' as 'absolute',
        bgcolor: 'background.paper',
        boxShadow: 24,
        height: 'auto',
        width: '400px',
        p: 2
    };


    return (
        <StyledSaveModal
            open={props.show}
            onClose={props.handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={modalStyle}>
                <CloseSaveModal
                    type="button"
                    aria-label="Close"
                    onClick={props.handleCloseModal}>
                    <span aria-hidden="true">&times;</span>
                </CloseSaveModal>
                <Box>
                    <HeadingContainer>
                        <SaveIcon/>
                        <h2>Submission saved as draft</h2>
                        <p>If you want to continue your form later and receive a continue link via email, please enter a subject for your email and your email address</p>
                    </HeadingContainer>
                    <Fragment>
                        <SaveDraftForm onSubmit={props.handleModalSubmit}>
                            <SaveDraftGroup>
                                <SaveDraftControlLabel>
                                    Email Subject *
                                </SaveDraftControlLabel>
                                <SaveDraftControl type="text"
                                       value={props.saveEmailSubject}
                                       onChange={props.handleEmailSubjectChange}
                                       placeholder="Enter your email subject"/>
                                <span className="error-message">{props.saveEmailSubjectErrorMessage}</span>
                            </SaveDraftGroup>
                            <SaveDraftGroup>
                                <SaveDraftControlLabel>
                                    Email Address *
                                </SaveDraftControlLabel>
                                <SaveDraftControl type="email"
                                       value={props.saveEmailAddress}
                                       onChange={props.handleEmailAddressChange}
                                       placeholder="Enter your email address"/>
                                <span className="error-message">{props.saveEmailAddressErrorMessage}</span>
                            </SaveDraftGroup>
                            <Button
                                type="submit"
                                variant="contained"
                                size="large"
                                color="secondary"
                                disableElevation
                                fullWidth={true}
                                disabled={props.saveEmailAddressErrorMessage !== '' &&
                                    props.saveEmailSubjectErrorMessage !== '' ||
                                    props.saveEmailAddress === ''}
                            >
                                Send
                            </Button>
                            <Tooltip title={props.copySuccess}
                                     onClose={props.copiedToClipboard}
                                     arrow
                                     slotProps={{
                                         popper: {
                                             modifiers: [
                                                 {
                                                     name: 'offset',
                                                     options: {
                                                         offset: [0, -10],
                                                     },
                                                 },
                                             ],
                                         },
                                     }}>
                                <Button
                                    onClick={props.copyToClipboard}
                                    type="button"
                                    className="copyButton"
                                    variant="contained"
                                    size="large"
                                    color="primary"
                                    disableElevation
                                    fullWidth={true}
                                >
                                    Copy Link
                                </Button>
                            </Tooltip>
                            <SaveDraftGroup>
                                <SaveDraftControl
                                       disabled
                                       value={props.savedStateAppUrl}/>
                            </SaveDraftGroup>
                        </SaveDraftForm>
                    </Fragment>
                </Box>
            </Box>
        </StyledSaveModal>
    )
}

export default SaveModal;